import isDmnChanged from 'pages/rules/utils/isDmnChanged';

// Constants for better maintainability
const excludedKeys = new Set(['output_formula', 'rule_applicability']);
const jsonCompareKeys = new Set([
  'output_formula_json',
  'rule_applicability_json',
]);
const ruleSpecificKeys = new Set([
  'reporting_payout_variable_name',
  'rule_description',
  'rule_is_active',
  'unique_id',
  'file',
  'file_type',
  'rule_file_path_json',
]);

// Helper functions for specific comparison logic
const compareRuleOutputConfig = (prev: any, curr: any): boolean =>
  prev !== undefined && JSON.stringify(prev) !== JSON.stringify(curr);

const compareJsonValueKeys = (prev: any, curr: any): boolean =>
  prev?.value !== curr?.value;

const compareDefault = (prev: any, curr: any): boolean =>
  prev !== undefined && prev !== curr;

const changedKeysFn = (
  currentValue: Record<string, any>,
  previousValues: Record<string, any> | null | undefined,
  currentXmlValue: any,
  previousXmlValue: any
): { changedKeys: string[]; dmnChanged: boolean; valuesChanged: boolean } => {
  // Early return if no previous values
  if (!previousValues) {
    return { changedKeys: [], dmnChanged: false, valuesChanged: false };
  }

  const changedKeys = Object.keys(currentValue).filter((key) => {
    // Skip excluded keys
    if (excludedKeys.has(key)) {
      return false;
    }

    const prevValue = previousValues[key];
    const currValue = currentValue[key];

    // Handle different key types with specific comparison logic
    if (key === 'rule_output_config') {
      return compareRuleOutputConfig(prevValue, currValue);
    }

    if (jsonCompareKeys.has(key)) {
      return compareJsonValueKeys(prevValue, currValue);
    }

    return compareDefault(prevValue, currValue);
  });

  const dmnChanged = isDmnChanged(currentXmlValue, previousXmlValue);

  // Determine if non-rule-specific values changed
  const valuesChanged = changedKeys.some((key) => !ruleSpecificKeys.has(key));

  return { changedKeys, dmnChanged, valuesChanged };
};

export default changedKeysFn;
